import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Segment = /*#__PURE__*/function () {
  function Segment() {
    _classCallCheck(this, Segment);
  }

  _createClass(Segment, null, [{
    key: "identify",
    value: function identify(user) {
      if (this.checkIfLoaded()) {
        window.analytics.identify(user._id, {
          name: user.info.name,
          email: user.info.email,
          phone: user.info.phone
        });
      }
    }
  }, {
    key: "page",
    value: function page() {
      if (this.checkIfLoaded()) {
        window.analytics.page();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.checkIfLoaded()) {
        window.analytics.reset();
      }
    }
  }, {
    key: "track",
    value: function track(event) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.checkIfLoaded()) {
        window.analytics.track(event, properties);
      }
    }
  }]);

  return Segment;
}();

Segment.checkIfLoaded = function () {
  return !!window.analytics;
};

export default Segment;